import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import fieldTranslations from 'modules/payroll_integrations_datev_api/lib/fieldTranslations'
import type { Sync } from 'modules/payroll_integrations_datev_lauds/lib/IncidenceSync/store'

const Unavailable = ({ sync }: { sync: Sync }) => {
  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.datev_lauds.hiring.unavailable.title')}
      </Text.Header2>
      <Box>{i18n.t('payroll_integrations.incidences.datev_lauds.hiring.unavailable.message')}</Box>
      <Box component="ul" paddingX="s8">
        {
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          (sync.unavailable_fields as string[])
            .filter(
              (field) => !['missing_salary_code', 'missing_legal_entity_mapping'].includes(field)
            )
            .map((field) => {
              return (
                <Box component="li" key={field}>
                  {fieldTranslations.t(field)}
                </Box>
              )
            })
        }
      </Box>
    </>
  )
}

export default Unavailable
